import { HttpErrorResponse } from "@angular/common/http";

import { MessageModel } from "@models/message.model";
import { createReducer, on } from "@ngrx/store";

import {
  MESSAGE_ACTION_FAILURE,
  SET_MESSAGES,
  SET_MESSAGES_LOADING,
} from "./messages.action";

export interface MessageState {
  messages: MessageModel[];
  messagesLoading: boolean;
  error: HttpErrorResponse | null;
}

const initialState: MessageState = {
  messages: [],
  messagesLoading: false,
  error: null,
};

export const MESSAGE_REDUCER = createReducer(
  initialState,
  on(MESSAGE_ACTION_FAILURE, (state, action): MessageState => {
    return {
      ...state,
      error: action.error,
    };
  }),
  on(
    SET_MESSAGES_LOADING,
    (state: MessageState, action: { loading: boolean }): MessageState => {
      return {
        ...state,
        messagesLoading: action.loading,
      };
    }
  ),

  on(
    SET_MESSAGES,
    (state: MessageState, action: { data: MessageModel[] }): MessageState => {
      return {
        ...state,
        messages: action.data,
      };
    }
  )
);
